import { ReportFilterType } from "components/Reports/ReportFilter";
import qs from "qs";

export const redirectToCategories = ({
  uuid,
  groupId,
  entityId,
  isAdmin,
  filter,
}: {
  uuid: string;
  groupId: string;
  entityId: string;
  isAdmin: boolean;
  filter: ReportFilterType;
}) => {
  const baseUrl = "/books/categories";

  const query = qs.stringify(
    {
      entity: entityId,
      category: uuid,
      startDate: filter.START_DATE,
      endDate: filter.END_DATE,
      hideZero: filter.HIDE_ZERO,
      accountingMethod: filter.ACCOUNTING_METHOD,
      ...(isAdmin && { company: groupId }),
    },
    { skipNulls: true, addQueryPrefix: true }
  );

  return `${baseUrl}${query}`;
};
